import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
export default function Servicearea() {
  return <section id="servicearea" data-nav="light" className="bg-background text-foreground py-14 lg:py-20 border-b border-border/50">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column: Information */}
          <div className="flex flex-col gap-4">
            <div>
              <Badge variant="secondary" className="font-normal text-xs uppercase tracking-wider">
                Vårt arbetsområde
              </Badge>
            </div>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-foreground">
              Badrumsrenovering på flera orter i Värmland
            </h2>

            <p className="text-muted-foreground text-base sm:text-lg leading-relaxed mt-1">Vi utför badrumsrenoveringar på flera orter i Värmland, bland annat i <Link className="underline cursor-pointer text-primary" to="/BathroomRenovationArvikaPage">Arvika</Link>, Charlottenberg, Åmotfors och <Link className="underline cursor-pointer text-primary" to="/BathroomRenovationKarlstadPage">Karlstad</Link>. Vi hjälper till med både funktionella standardbadrum och mer exklusiva badrum, med lösningar anpassade efter bostaden, dina önskemål och projektets omfattning.</p>

            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 pt-2 text-sm sm:text-base">
              <Link className="text-foreground font-medium hover:text-primary transition-colors inline-flex items-center gap-1.5 underline cursor-pointer" to="/BathroomRenovationArvikaPage">
                <span className="size-1.5 rounded-full bg-primary" />
                Arvika
              </Link>
              <span className="text-foreground font-medium inline-flex items-center gap-1.5">
                <span className="size-1.5 rounded-full bg-muted-foreground/50" />
                Charlottenberg
              </span>
              <span className="text-foreground font-medium inline-flex items-center gap-1.5">
                <span className="size-1.5 rounded-full bg-muted-foreground/50" />
                Åmotfors
              </span>
              <Link className="text-foreground font-medium hover:text-primary transition-colors inline-flex items-center gap-1.5" to="/BathroomRenovationKarlstadPage">
                <span className="size-1.5 rounded-full bg-primary" />
                Karlstad
              </Link>
            </div>
          </div>

          {/* Right Column: Decorative Vector Map */}
          <div className="bg-card border border-border rounded-lg shadow-xs p-6 sm:p-8">
            <div className="w-full relative flex items-center justify-center">
              <svg viewBox="0 0 520 440" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto max-w-md mx-auto" aria-label="Karta över Värmland med markerade orter">
                {/* County stylized outline */}
                <path d="M170 30 C220 20 310 35 370 70 C430 105 450 160 440 230 C430 300 390 350 350 390 C290 415 220 405 180 375 C140 345 110 320 90 260 C70 200 90 120 130 65 Z" className="fill-secondary stroke-border" strokeWidth="1.5" />

                {/* Decorative subtle region accent curve */}
                <path d="M200 70 Q 300 130 380 220" className="stroke-border/60" strokeWidth="1" strokeDasharray="4 4" fill="none" />

                {/* Lake Vänern shoreline hint */}
                <path d="M250 400 C290 370 340 375 390 395" className="stroke-primary/20" strokeWidth="2" fill="none" />

                {/* 1. Charlottenberg (Northwest) */}
                <g className="translate-y-0">
                  <circle cx="140" cy="140" r="12" className="fill-primary/10" />
                  <circle cx="140" cy="140" r="5" className="fill-primary" />
                  <text x="130" y="120" textAnchor="end" className="fill-foreground font-sans text-xs font-medium select-none">
                    Charlottenberg
                  </text>
                </g>

                {/* 2. Åmotfors (West) */}
                <g className="translate-y-0">
                  <circle cx="175" cy="195" r="12" className="fill-primary/10" />
                  <circle cx="175" cy="195" r="5" className="fill-primary" />
                  <text x="162" y="200" textAnchor="end" className="fill-foreground font-sans text-xs font-medium select-none">
                    Åmotfors
                  </text>
                </g>

                {/* 3. Arvika (Central-West) */}
                <g className="translate-y-0">
                  <circle cx="230" cy="225" r="14" className="fill-primary/15" />
                  <circle cx="230" cy="225" r="6" className="fill-primary" />
                  <text x="248" y="222" className="fill-foreground font-sans text-xs font-semibold select-none">
                    Arvika
                  </text>
                </g>

                {/* 4. Karlstad (Southeast) */}
                <g className="translate-y-0">
                  <circle cx="345" cy="305" r="14" className="fill-primary/15" />
                  <circle cx="345" cy="305" r="6" className="fill-primary" />
                  <text x="363" y="310" className="fill-foreground font-sans text-xs font-semibold select-none">
                    Karlstad
                  </text>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>;
}